module.exports = __webpack_public_path__ + "static/img/C4D0035.9fce7eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0035.jpg
// module id = zqE/
// module chunks = 0